/** Wirkungszeilen des Ergebnis-Dialogs (P4/B6a): Issues geschlossen + Score je Kanal. */
import { useTranslation } from 'react-i18next'

import type { ApplyOutcome } from '@/lib/api/channel-content-bulk'

export function ApplyOutcomeRows({ outcome, channelNameById }: { outcome: ApplyOutcome; channelNameById: Record<string, string> }) {
  const { t } = useTranslation()
  return (
    <div className="space-y-2" data-testid="apply-outcome-rows">
      <p className="text-sm font-medium text-neutral-900 dark:text-neutral-100">
        {t('channelContent.resultDialog.issuesClosed', { count: outcome.issues_closed })}
      </p>
      <p className="text-xs text-neutral-500">{t('channelContent.resultDialog.recomputedHint')}</p>
      {outcome.channel_deltas.map((d) => (
        <div key={d.channel_id} className="flex items-center justify-between rounded-md bg-neutral-50 px-3 py-2 text-sm dark:bg-neutral-800/50">
          <span>{channelNameById[d.channel_id] ?? d.channel_id}</span>
          <span className="font-medium tabular-nums">{d.score_before} → {d.score_after}</span>
        </div>
      ))}
    </div>
  )
}
